/**
 * PD Variant URL Init
 * URL'de ?variant= parametresi varken doğru ürün resmini seçer.
 * Shopify product.js endpoint'inden featured_media.id alır
 * ve media-gallery'de setActiveMedia çağırır.
 */
(function() {
  'use strict';

  var urlParams = new URLSearchParams(window.location.search);
  var urlVariant = urlParams.get('variant');
  if (!urlVariant) return;

  // Shopify product.js'den doğru media ID'yi al
  var productUrl = window.location.pathname + '.js';

  fetch(productUrl)
    .then(function(res) { return res.json(); })
    .then(function(product) {
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(urlVariant)) {
          variant = product.variants[i];
          break;
        }
      }

      if (!variant) return;
      if (!variant.featured_media) return;

      var mediaId = variant.featured_media.id;

      // media-gallery hazır olunca çağır
      function activate() {
        var mg = document.querySelector('media-gallery');
        if (!mg || typeof mg.setActiveMedia !== 'function') return;

        var sectionId = mg.dataset.section || '';
        var fullId = sectionId ? sectionId + '-' + mediaId : String(mediaId);

        var mediaItem = mg.querySelector('[data-media-id="' + fullId + '"]');
        if (!mediaItem) {
          mediaItem = mg.querySelector('[data-media-id$="-' + mediaId + '"]');
        }

        if (mediaItem) {
          mg.setActiveMedia(mediaItem.dataset.mediaId, true);
        }
      }

      if (window.customElements && window.customElements.whenDefined) {
        window.customElements.whenDefined('media-gallery').then(function() {
          setTimeout(activate, 200);
        });
      } else {
        window.addEventListener('load', function() {
          setTimeout(activate, 500);
        });
      }
    })
    .catch(function(err) {
      console.log('[PD] product.js fetch failed:', err);
    });
})();
